module.exports = __webpack_public_path__ + "img/sipky-5.d9ca2678.png";